export const formatNow = (locale = 'it-IT') => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
  return new Date().toLocaleDateString(locale, options)
}